import React, { useEffect, useState } from "react";
import "../assets/css/gallery.css";
import Zoomimage from "../Component/Zoomimage";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import img001 from "../assets/images/c1.jpg";
import img002 from "../assets/images/c2.jpg";
import img003 from "../assets/images/c3.jpg";
import img004 from "../assets/images/c4.jpg";
import img005 from "../assets/images/c5.jpg";
import img006 from "../assets/images/c6.jpg";
import Whatsappcatlog from "../Component/Media/Whatsappcatlog";

// Gallery Images array
const galleryImages = [
  { id: 1, src: img001, alt: "Image 1" },
  { id: 2, src: img002, alt: "Image 2" },
  { id: 3, src: img003, alt: "Image 3" },
  { id: 4, src: img004, alt: "Image 4" },
  { id: 5, src: img005, alt: "Image 5" },
  { id: 6, src: img006, alt: "Image 6" },
  { id: 7, src: img003, alt: "Image 7" },
  // { id: 8, src: img004, alt: "Image 8" },
  // { id: 9, src: img006, alt: "Image 1" },
  // { id: 10, src: img003, alt: "Image 4" },
  // { id: 11, src: img004, alt: "Image 6" },
];

const Gallery = ({ mainimage, name }) => {
  const [mainImage, setMainImage] = useState(mainimage);
  const [activeThumbnail, setActiveThumbnail] = useState(
    galleryImages.find((img) => img.src === mainimage)?.id || 1
  );

  useEffect(() => {
    setMainImage(mainimage);
    setActiveThumbnail(galleryImages.find((img) => img.src === mainimage)?.id || 1);
  }, [mainimage]);

  const thumbnailsPerPage = 4; // 4 per row, 8 total (2 rows)
  const [startIndex, setStartIndex] = useState(0);

  const handlePrev = () => setStartIndex((prev) => Math.max(prev - thumbnailsPerPage * 2, 0));

  const handleNext = () => {
    const maxIndex = Math.max(galleryImages.length - thumbnailsPerPage * 2, 0);
    setStartIndex((prev) => Math.min(prev + thumbnailsPerPage * 2, maxIndex));
  };

  const visibleThumbnails = galleryImages.slice(startIndex, startIndex + thumbnailsPerPage * 2);

  const handleThumbnailClick = (src, id) => {
    setMainImage(src);
    setActiveThumbnail(id);
  };

  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);


  return (
    <>
      <div className="gallery-container">
        <div className="row">
          {/* Main Image */}
          <div className="col-12 mb-2">
            <h2 style={{ textAlign: "center", color: "rgb(103 99 99)" }}>
              ABBY <span style={{ color: "rgb(246 135 19)" }}>{name}</span>
            </h2>

            {isLoading ? (
              <Skeleton height={500} width="100%" />
            ) : (
              <div className="main-image position-relative">
                  <div className="share-hover" style={{ position: "absolute", top: "51px", right: "15px", opacity: "10" }}>
                     <Whatsappcatlog />
                </div>

                <img
                  src={mainImage}
                  alt="Main"
                  className="main-image-img w-100"
                  onClick={() => handleImageClick(mainImage)}
                  style={{ cursor: "zoom-in" }}
                />
                <span className="zoomicon" onClick={() => handleImageClick(mainImage)}>
                  <i className="bi bi-zoom-in"></i>
                </span>
              </div>
            )}
          </div>

          {/*----- Thumbnails 2-line Horizontal Scroll --------*/}

          <div className="col-12 d-flex align-items-center">
            {isLoading ? (
              <Skeleton height={100} width="100%" />
            ) : (
              <div className="d-flex align-items-center w-100 mt-2">

  {galleryImages.length > 7 && (
    <button onClick={handlePrev} className="nav-btn me-2" disabled={startIndex === 0}>
      <i className="bi bi-chevron-left"></i>
    </button>
  )}

  <div className="thumbnail-container flex-grow-1">
    <div className="thumbnail-grid-horizontal" style={{ cursor: "pointer" }}>
      {visibleThumbnails.map((img) => (
        <div
          key={img.id}
          className={`thumbnail-wrapper ${activeThumbnail === img.id ? "active" : ""}`}
          onClick={() => handleThumbnailClick(img.src, img.id)}
        >
          <img src={img.src} alt={img.alt} />
        </div>
      ))}
    </div>
  </div>

  {galleryImages.length > 7 && (
    <button
      onClick={handleNext}
      className="nav-btn ms-2"
      disabled={startIndex + thumbnailsPerPage * 2 >= galleryImages.length}
    >
      <i className="bi bi-chevron-right"></i>
    </button>
  )}
</div>

            )}
          </div>
        </div>
      </div>
      <Zoomimage showModal={showModal} handleCloseModal={handleCloseModal} modalImage={modalImage} />
    </>
  );
};
export default Gallery;
